import { getUser } from "./getUser";

export const getIsUserImpersonating = (): boolean => {
  const user = getUser();
  return !!user?.impersonating;
};
